import {
  CentreData,
  MappingData
} from "../models/support/SupportApp";

// Centre Constants 
export const GET_Centre = "GET_Centre";
export const SET_Centre_DATA = "SET_Centre_DATA";

// Mapping Constants 
export const GET_Mapping = "GET_Mapping";
export const SET_Mapping_DATA = "SET_Mapping_DATA";

// Centre Action Interfaces 
export interface GetCentreAction {
  type: typeof GET_Centre;
  payload: { centre: CentreData[]; centreCount: number };
}

export interface SetCentreDetailAction {
  type: typeof SET_Centre_DATA;
  payload: CentreData;
}

// Mapping Action Interfaces 
export interface GetMappingAction {
  type: typeof GET_Mapping;
  payload: { mapping: MappingData[]; mappingCount: number };
}

export interface SetMappingDetailAction {
  type: typeof SET_Mapping_DATA;
  payload: MappingData;
}

// Support ActionTypes 
export type SupportActionTypes =
  | GetCentreAction
  | SetCentreDetailAction
  | GetMappingAction
  | SetMappingDetailAction;
